export const PAYOUT_SETUP_STATUS_DEFERRED = 'deferred';
export const PAYOUT_SETUP_STATUS_CONNECTED = 'connected';
export const PAYMENT_MODE_DEFERRED_PAYOUT_WALLET = 'deferred_payout_wallet';

const PAYOUT_SETUP_STATUSES_WITH_PREFERENCE = [
  PAYOUT_SETUP_STATUS_DEFERRED,
  PAYOUT_SETUP_STATUS_CONNECTED,
];

const profileData = user => user?.attributes?.profile || {};
const publicData = user => profileData(user)?.publicData || {};
const protectedData = user => profileData(user)?.protectedData || {};

export const deferredPayoutProfileUpdate = status => {
  const isDeferred = status === PAYOUT_SETUP_STATUS_DEFERRED;

  return {
    publicData: {
      payoutSetupStatus: status,
      hasDeferredPayoutSetup: isDeferred,
    },
    protectedData: {
      payoutSetupStatus: status,
      hasDeferredPayoutSetup: isDeferred,
    },
  };
};

export const hasDeferredPayoutSetup = user => {
  const pub = publicData(user);
  const prot = protectedData(user);

  return (
    pub.payoutSetupStatus === PAYOUT_SETUP_STATUS_DEFERRED ||
    prot.payoutSetupStatus === PAYOUT_SETUP_STATUS_DEFERRED ||
    pub.hasDeferredPayoutSetup === true ||
    prot.hasDeferredPayoutSetup === true
  );
};

export const hasConnectedStripePayouts = user => {
  return !!(
    user?.stripeAccount?.id ||
    user?.attributes?.stripeConnected ||
    user?.attributes?.stripeVerified
  );
};

export const hasPayoutSetupPreference = user => {
  const pub = publicData(user);
  const prot = protectedData(user);
  const publicStatus = pub.payoutSetupStatus;
  const protectedStatus = prot.payoutSetupStatus;

  return (
    PAYOUT_SETUP_STATUSES_WITH_PREFERENCE.includes(publicStatus) ||
    PAYOUT_SETUP_STATUSES_WITH_PREFERENCE.includes(protectedStatus) ||
    pub.hasDeferredPayoutSetup === true ||
    prot.hasDeferredPayoutSetup === true ||
    hasConnectedStripePayouts(user)
  );
};

export const shouldUseDeferredPayout = provider => {
  return hasDeferredPayoutSetup(provider) && !hasConnectedStripePayouts(provider);
};

export const isDeferredPayoutListing = listing => {
  return shouldUseDeferredPayout(listing?.author);
};

export const isDeferredPayoutTransaction = transaction => {
  return (
    transaction?.attributes?.protectedData?.paymentMode === PAYMENT_MODE_DEFERRED_PAYOUT_WALLET ||
    transaction?.attributes?.metadata?.paymentMode === PAYMENT_MODE_DEFERRED_PAYOUT_WALLET
  );
};

export const deferredPayoutOrderProtectedData = {
  paymentMode: PAYMENT_MODE_DEFERRED_PAYOUT_WALLET,
};

export const getDeferredPayoutRequestTransition = (process, transitionName) => {
  const { transitions = {} } = process || {};

  return transitionName === transitions.REQUEST_PAYMENT_AFTER_INQUIRY
    ? transitions.REQUEST_PAYMENT_AFTER_INQUIRY_DEFERRED || transitionName
    : transitionName === transitions.REQUEST_PAYMENT_TO_ACCEPT_OFFER
    ? transitions.REQUEST_PAYMENT_TO_ACCEPT_OFFER_DEFERRED || transitionName
    : transitionName === transitions.REQUEST_PAYMENT
    ? transitions.REQUEST_PAYMENT_DEFERRED || transitionName
    : transitionName;
};

export const getDeferredPayoutConfirmTransition = process => {
  return process?.transitions?.CONFIRM_PAYMENT_DEFERRED || process?.transitions?.CONFIRM_PAYMENT;
};

export const getWalletBalance = currentUser => {
  const walletBalance = protectedData(currentUser)?.walletBalance || {};

  return {
    amount: walletBalance.amount || 0,
    currency: walletBalance.currency || null,
    pendingTransactions: walletBalance.pendingTransactions || [],
    availableTransactions: walletBalance.availableTransactions || [],
    withdrawnTransactions: walletBalance.withdrawnTransactions || [],
  };
};

export const isWalletBalanceAvailable = currentUser => {
  return getWalletBalance(currentUser).amount > 0;
};
